import {
  ModalContainer,
  Modal,
  Iconend,
  HeadingCenter,
  TransparentBtn,
  AlignCenterWithMargin,
  GradingModalImage,
} from "./GradingModal.styles";
import CrossIcon from "../../assets/icons/cross.svg";
import { ActionModalProps } from "../../types";
import Button from "../button/Button";

function ActionModal(props: ActionModalProps) {
  const {
    onCloseModal,
    text,
    firstBtnText,
    secondBtnText,
    isDelete,
    actionHandler,
  } = props;
  return (
    <ModalContainer>
      <Modal>
        <Iconend>
          <GradingModalImage
            onClick={onCloseModal}
            src={CrossIcon}
            alt="cross"
          />
        </Iconend>
        <HeadingCenter>{text}</HeadingCenter>
        <div>
          <div>
            <Button
              text={firstBtnText}
              onClick={actionHandler}
              disabled={false}
              style={{
                width: "100%",
                height: "36px",
                background: isDelete && "rgba(202, 43, 29, 1)",
              }}
            />
          </div>
          <AlignCenterWithMargin>
            <TransparentBtn onClick={onCloseModal}>
              {secondBtnText}
            </TransparentBtn>
          </AlignCenterWithMargin>
        </div>
      </Modal>
    </ModalContainer>
  );
}

export default ActionModal;
